import { useGetFundCasTemplates } from "@vega-api/generated/cas-settings-v1/cas-settings-v1";
import { DefaultErrorPanel } from "@vega-core/components/Cards/DefaultErrorPanel/DefaultErrorPanel";
import { LoadingSpinner } from "@vega-core/components/Loaders/LoadingSpinner/LoadingSpinner";
import { m } from "@vega-core/paraglide/messages";

export const TemplateLibraryTab = () => {
  const { data: templatesData, isLoading, isError } = useGetFundCasTemplates();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <LoadingSpinner />
      </div>
    );
  }

  if (isError) {
    return <DefaultErrorPanel />;
  }
  const templates = templatesData?.data || [];

  if (templates.length === 0) {
    return (
      <div className="flex justify-center items-center h-64 text-text/secondary">
        {m.settings_templateLibrary_emptyState()}
      </div>
    );
  }

  return (
    <div className="border-1 border-border/primary rounded-t-companyBorderRadius rounded-b-companyBorderRadius">
      {templates.map((template) => (
        <div
          className="flex items-left justify-left py-4 sm:py-5 px-3 md:px-4 text-sm font-medium text-text/primary border-b border-border/primary last:border-b-0"
          key={template.templateKey}
        >
          {template.templateName}
        </div>
      ))}
    </div>
  );
};
